import React, { useEffect, useState } from 'react';
import './Icon.css';
import { Whatsapp } from '../../assets/images/icons/Social';
import { getWhatsAppDetails } from '../../services/api';

function WhatsApp() {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    const fetchWhatsAppDetails = async () => {
        try {
          const { number, welcome_message } = await getWhatsAppDetails();
          setUrl(`https://wa.me/${number}?text=${encodeURIComponent(welcome_message)}`);
        } catch (error) {
          console.error('Failed to fetch WhatsApp details:', error);
        }
    };

    fetchWhatsAppDetails();
  }, []);

  if (!url) return null;

  return (
    <a
      aria-label="Chat on WhatsApp"
      href={url}
      className="side-icon whatsapp-icon"
      target="_blank"
      rel="noreferrer"
    >
      <Whatsapp />
    </a>
  );
}

export default WhatsApp;
